import { LandProfileDisplay } from '@cibo/ui'
import { FieldColumnProps } from './types'

interface ColumnProps extends FieldColumnProps {
  acres?: (acres: number) => string
}

export const fieldAcresColumn = ({ t, acres, ...overrides }: ColumnProps) => ({
  field: 'acres',
  headerName: t('acres', { ns: '@cibo/landmanager' }),
  type: 'number' as const,
  minWidth: 80,
  flex: 1,
  valueFormatter: (value: number) => (acres ? acres(value) : LandProfileDisplay.acreage(value)),
  ...overrides,
})
